module.exports = __webpack_public_path__ + "static/media/favicon-eventxtra.5d6b385c.ico";